import React, { useMemo } from 'react';

const PIECES = ['⭐', '🎉', '🌈', '🎈', '✨', '🏆', '💫'];

// Lightweight celebration overlay — no external library.
// Render with `active` truthy to show a one-shot confetti burst.
// Pass a changing `burstKey` (e.g. a counter) to retrigger the animation.
const Confetti = ({ active, burstKey = 0, count = 22 }) => {
  // Randomized, stable per burst so positions don't reshuffle every render.
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: 2.2 + Math.random() * 1.2,
        emoji: PIECES[i % PIECES.length],
      })),
    [burstKey, count]
  );

  if (!active) return null;

  return (
    <div className="sb-confetti" aria-hidden="true">
      {pieces.map((p, i) => (
        <span
          key={i}
          style={{
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        >
          {p.emoji}
        </span>
      ))}
    </div>
  );
};

export default Confetti;
